module.exports = __webpack_public_path__ + "static/media/3.dde5edd8.jpg";